/**
 * Canonical variant purchasability — the same rules the shared StockIndicator
 * and AddToCart apply (manage_inventory / allow_backorder / inventory_quantity):
 *
 *   1. manage_inventory === false → purchasable (inventory not tracked)
 *   2. allow_backorder === true  → purchasable (even at qty 0)
 *   3. inventory_quantity > 0    → purchasable
 *
 * `=== false` / `=== true` comparisons keep undefined fields defensive
 * (unloaded → treated as managed/no-backorder → falls to the qty check).
 */
export function isPurchasableVariant(variant: any): boolean {
  if (!variant) return false
  if (variant.manage_inventory === false) return true
  if (variant.allow_backorder === true) return true
  return (variant.inventory_quantity ?? 0) > 0
}

/** First variant the shopper can actually buy, else null. Product cards
 * use this for their initial price display and button state. */
export function findFirstPurchasableVariant(variants: any[] | undefined | null): any | null {
  if (!Array.isArray(variants)) return null
  return variants.find(isPurchasableVariant) ?? null
}
